<template>
  <BField
    label="Nombre o razón social"
    label-for="customer-trade-name"
  >
    <BAutocomplete
      id="customer-trade-name"
      ref="input"
      name="customer-trade-name"
      placeholder="Empresa SA de CV"
      field="companyName"
      icon="domain"
      :value="companyName"
      :data="customers"
      :loading="loading"
      :required="required"
      :disabled="disabled"
      open-on-focus
      @typing="getCustomers"
      @input="onInput"
      @select="onSelect"
    >
      <template slot-scope="props">
        <div class="columns is-multiline">
          <div class="column is-2">
            email:
          </div>
          <div class="column is-10">
            {{ props.option.email }}
          </div>
          <div class="column is-2">
            name
          </div>
          <div class="column is-10">
            {{ props.option.name }}
          </div>
          <div class="column is-2">
            RFC:
          </div>
          <div class="column is-10">
            {{ props.option.rfc }}
          </div>
        </div>
      </template>
    </BAutocomplete>
  </BField>
</template>

<script>
import debounce from 'lodash/debounce';
import { mapState } from 'vuex';
import moment from 'moment';

export default {
  name: 'SearcherByTradeName',
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: mapState({
    companyName: state => state.customers.companyName,
    customers: state => state.customers.list,
  }),
  watch: {
    companyName() {
      this.checkHtmlValidity();
    },
  },
  methods: {
    checkHtmlValidity() {
      setTimeout(() => {
        if (this.$refs.input) this.$refs.input.checkHtml5Validity();
      }, 10);
    },
    onInput(value) {
      this.$store.commit('invoice/setValue', { accessor: 'receiverName', value });
      this.$store.commit('customers/setValue', { accessor: 'companyName', value });
    },
    getCustomers: debounce(async function getCustomers(companyName) {
      if (companyName.length > 3) {
        this.loading = true;

        try {
          await this.$store.dispatch('customers/getAll', { size: 50, page: 1, companyName });
        } catch (error) {
          // eslint-disable-next-line
          console.error(error);
        }

        this.loading = false;
      }
    }, 400),
    onSelect(option = {}) {
      if (option) {
        const {
          name,
          email,
          rfc,
          companyName,
          creditDays,
          creditLimit,
          debts,
          debtsExpired,
          id,
          zipCode,
          taxRegime,
        } = option;

        const Days = creditDays > 0 ? creditDays : 1;
        const expirationDate = moment().add(Days, 'days').toDate();

        this.$store.commit('customers/setValues', {
          name,
          email,
          rfc,
          companyName,
          creditDays,
          creditLimit,
          debts,
          debtsExpired,
          id,
        });

        this.$store.commit('users/setValues', {
          name,
          email,
          rfc,
          companyName,
        });

        this.$store.commit('invoice/setValues', {
          receiverName: companyName,
          receiverRfc: rfc,
          receiverZipCode: zipCode,
          receiverTaxRegime: taxRegime,
          'operation.expirationDate': expirationDate,
        });

        this.$emit('select', option);
      }
    },
  },
};
</script>

<style scoped>
.column {
  padding: 0.15rem 0.25rem;
}

#customer-rfc {
  text-transform: uppercase;
}
</style>
